import { API as IdentityService, Org } from '@weave/schema-gen-ts/dist/apis/api/identity/v1/api.pb';
import appConfig from '@frontend/env';
import { bindHTTP } from '@frontend/schema';

export const IdentityServiceSchema = bindHTTP(IdentityService);

export const fetchOrgsData = async (orgIds: string[]): Promise<Org[]> => {
  if (!orgIds || !orgIds.length) return [];

  const results = await Promise.allSettled(
    orgIds.map((orgId) =>
      IdentityServiceSchema.GetOrg({ orgId }, { skipValidation: true, baseUrl: appConfig.BACKEND_API_V2 })
    )
  );

  const orgsData = results
    .filter((result) => result.status === 'fulfilled')
    .map((result) => (result as PromiseFulfilledResult<Org>).value);
  return orgsData;
};
